module.exports = __webpack_public_path__ + "static/media/a6.2966ab8e.jpg";